import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import Fab from '@mui/material/Fab';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';
import { ChangeEvent } from 'react';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { BaseSearch, BaseTooltip } from '@mgm/common/components/base';
import { helpActions } from '../../../store/help/slice';
import { useAppDispatch } from '../../../hooks/useAppStore';
import { ReactComponent as FeedBackIcon } from '../static/ic_feedback.svg';
import discordLogo from '../../../assets/discord.png';

const HelpHeader = () => {
  const { t } = useTranslation(['help', 'inputs']);
  const theme = useTheme() as TCustomTheme;
  const { isMobile, isLight } = useCustomTheme(theme);
  const dispatch = useAppDispatch();

  const openFeedbackNav = () => {
    dispatch(helpActions.setIsOpenFeedbackNav(true));
  };

  const openDiscordNav = () => {
    dispatch(helpActions.setIsOpenDiscordNav(true));
  };

  const handleSearch = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(helpActions.setSearchArticle(event.target.value));
  };

  return (
    <Stack pt={4} textAlign="center">
      <Typography variant="h3">{t('askUsAnything')}</Typography>
      <Typography pt={1} variant="body1">{t('needSomethingCleared')}</Typography>
      <Box
        width={isMobile ? 'auto' : 300}
        {...(!isMobile && {
          mx: 'auto',
        })}
        display="flex"
        mt={4}
      >
        <BaseSearch onChange={handleSearch} isDisplayBorder placeholder={t('search', { ns: 'inputs' })} />
        <BaseTooltip tooltipText={t('sendFeedbackToManageMate')}>
          <Fab
            onClick={openFeedbackNav}
            size="small"
            sx={{
              backgroundColor: 'background.paper',
              boxShadow: isLight
                ? 'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px'
                : '',
              ml: 2,
              '&:hover': {
                backgroundColor: 'inherit',
              },
            }}
          >
            <SvgIcon color="primary" component={FeedBackIcon} inheritViewBox />
          </Fab>
        </BaseTooltip>
        <Fab
          onClick={openDiscordNav}
          size="small"
          sx={{
            backgroundColor: 'background.paper',
            boxShadow: isLight
              ? 'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px'
              : '',
            ml: 2,
            '&:hover': {
              backgroundColor: 'inherit',
            },
          }}
        >
          <img src={discordLogo} width={25} alt="discord" />
        </Fab>
      </Box>
    </Stack>
  );
};

export {
  HelpHeader,
};
